import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    files: [],
    hasNext: false,

    loading: false,
    error: null,

    previewUrl: null,
    openPreview: false,

    detailsRow: null,
};

const archivedDocumentSlice = createSlice({
    name: 'archivedDocument',
    initialState,
    reducers: {
        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },
        loadingStopped(state) {
            state.loading = false;
        },
        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload.error;
        },

        archivedDocumentsLoaded(state, action) {
            state.files = action.payload.files;
            state.hasNext  = action.payload.hasNext;
        },

        previewUrlSet(state, action) {
            state.previewUrl = action.payload.url;
            state.openPreview = true;
        },
        previewClosed(state) {
            state.previewUrl = null;
            state.openPreview = false;
        },
        detailsOpened(state, action) {
            state.detailsRow = action.payload.row;
        },
        detailsClosed(state) {
            state.detailsRow = null;
        },
    },
});

export const { actions: archivedDocumentActions } = archivedDocumentSlice;
export const archivedDocumentReducer = archivedDocumentSlice.reducer;